// Texto 25 (E4): trazer um cliente dos contatos do celular para "Meus clientes".
// Só funciona no app novo (com o módulo de contatos); no app antigo e no computador o botão avisa ou some.
// A pessoa escolhe UM contato na tela do próprio sistema (nada é lido sem ela escolher); entra só nome, telefones,
// e-mail, aniversário, empresa e endereço. Nada vai para o My Planner.
import { Alert, Platform } from 'react-native';
import { requireOptionalNativeModule } from 'expo-modules-core';
import { t } from './i18n';
import { novoReg, salvarReg } from '../store/modulos';
import { aoSalvarBase, BASE, duplicadoDe, enderecoTexto } from './clientes';
import { semBloqueio } from '../auth/AuthContext';

/** No computador: não existe. No app antigo (sem o módulo): existe o botão, mas avisa que precisa atualizar. */
export const contatosNoAparelho = () => Platform.OS !== 'web';
export const contatosDisponivel = () => Platform.OS !== 'web' && !!requireOptionalNativeModule('ExpoContacts');

const p2 = (n: number) => String(n).padStart(2, '0');
const telBr = (s: string) => {
  let d = s.replace(/\D/g, '');
  if (d.startsWith('55') && d.length > 11) d = d.slice(2);
  if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return s.trim();
};

/** O contato escolhido vira os campos da ficha (Pessoa ou Empresa). Exportada para o teste. */
export function contatoParaCliente(x: any): Record<string, any> {
  const empresa = x?.contactType === 'company';
  const nome = String(x?.name || [x?.firstName, x?.lastName].filter(Boolean).join(' ') || x?.company || '').trim();
  const tels = (Array.isArray(x?.phoneNumbers) ? x.phoneNumbers : []).map((p: any) => telBr(String(p?.number ?? ''))).filter(Boolean);
  const tel = [...new Set<string>(tels)];
  const email = (Array.isArray(x?.emails) ? x.emails : []).map((e: any) => String(e?.email ?? '').trim()).find(Boolean) ?? '';
  const b = x?.birthday;
  const nasc = b && b.year && b.day != null && b.month != null ? `${b.year}-${p2(Number(b.month) + 1)}-${p2(Number(b.day))}` : '';
  const a = (Array.isArray(x?.addresses) ? x.addresses : [])[0];
  const c: Record<string, any> = {
    nome, tipo: empresa ? 'Empresa' : 'Pessoa', situacao: 'Ativo', whatsapp: true, autoriza: false,
    telefone: tel[0] ?? '', telefone2: tel[1] ?? '', email,
  };
  if (empresa) c.razao = String(x?.company ?? '').trim() || nome;
  else if (nasc) c.nascimento = nasc;
  if (!empresa && x?.company) c.notas = t('Trabalha em: {e}', { e: String(x.company) });
  if (a) {
    const cep = String(a.postalCode ?? '').replace(/\D/g, '');
    Object.assign(c, { rua: String(a.street ?? '').split('\n')[0].trim(), cidade: String(a.city ?? '').trim(), uf: String(a.region ?? '').trim(),
      cep: cep.length === 8 ? `${cep.slice(0, 5)}-${cep.slice(5)}` : String(a.postalCode ?? '').trim() });
    c.enderecoMapa = enderecoTexto(c);
  }
  return c;
}

/** Abre a lista de contatos do celular, a pessoa escolhe um, e ele entra em Meus clientes (avisa se já existe).
 *  onAbrir: abre a ficha criada (ou a que já existia); "Trazer outro" abre a lista de novo. */
export async function importarDosContatos(onAbrir?: (id: string) => void): Promise<void> {
  if (!contatosDisponivel()) {
    Alert.alert(t('Importar dos contatos'), t('Para trazer clientes dos contatos do celular, atualize o My Planner pela loja de aplicativos.'));
    return;
  }
  const Contacts = require('expo-contacts/legacy');
  try {
    if (Platform.OS === 'android') {
      const p = await semBloqueio(() => Contacts.requestPermissionsAsync()) as { granted: boolean };
      if (!p.granted) { Alert.alert(t('Importar dos contatos'), t('Sem a permissão de contatos não dá para escolher um contato. Você pode liberar nos ajustes do celular.')); return; }
    }
    const x = await semBloqueio(() => Contacts.presentContactPickerAsync());
    if (!x) return;   // fechou sem escolher
    const c = contatoParaCliente(x);
    if (!c.nome) { Alert.alert(t('Importar dos contatos'), t('Esse contato não tem nome.')); return; }
    const dup = duplicadoDe(c);
    if (dup) {
      Alert.alert(t('Já está em Meus clientes'), t('{nome} já está na lista.', { nome: String(dup.r.c.nome ?? '') }), [
        { text: t('Abrir'), onPress: () => onAbrir?.(dup.r.id) }, { text: t('Trazer outro'), onPress: () => { importarDosContatos(onAbrir); } }, { text: t('OK'), style: 'cancel' }]);
      return;
    }
    const r = novoReg('cliente', null, c);
    salvarReg(BASE, r);
    aoSalvarBase(r);
    Alert.alert(t('Cliente cadastrado'), t('{nome} entrou em Meus clientes. Confira a ficha e marque se ele autorizou receber mensagens.', { nome: c.nome }), [
      { text: t('Abrir'), onPress: () => onAbrir?.(r.id) }, { text: t('Trazer outro'), onPress: () => { importarDosContatos(onAbrir); } }, { text: t('OK'), style: 'cancel' }]);
  } catch (e: any) {
    Alert.alert(t('Não foi possível'), String(e?.message ?? e));
  }
}
